import { useEffect } from "react";

/**
 * keydown hander for given ref element
 * - only works when element is active
 * - handlers is a map of {keyCode: handler}
 * - doesn't support special characters (ignores them)
 */
const useKeyDown = (ref, handlers = {}) => {
  const onKeyDown = event => {
    if (ref && ref.current && ref.current !== document.activeElement) {
      return;
    }

    handlers[event.keyCode] && handlers[event.keyCode](event);
  };

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  });
};

export default useKeyDown;
